export const routesNames = Object.freeze({
	LOGIN: 'Login',
	HOMEPAGE: 'Homepage',
	MY_PROFILE: 'MyProfile',
	SCHEDULE: 'Schedule',

	RESTRICTED_ACCESS: 'RestrictedAccess',

	DATASETS: 'Datasets',
	DATASETS_GRIDS: 'DatasetsGrids',
	DATASETS_HISTORY: 'DatasetsHistory',
	DATASETS_RECORD_HISTORY: 'DatasetsRecordHistory',
	DATASETS_EDIT: 'DatasetsEdit',
	DATASETS_ADD: 'DatasetsAdd',

	INVENTORY: 'Inventory',
	INVENTORY_GRID: 'InventoryGrid',
	INVENTORY_FORM: 'InventoryForm',
	INVENTORY_FORM_HISTORY: 'InventoryFormHistory',

	REPORTS: 'Reports',
	REPORT_GRID: 'Report Grid',
	REPORT_GRID_CUSTOM: 'Report Grid Custom',
	REPORT_WORKBOOK: 'Report Workbook',

	TOOLS: 'Tools',

	ACTIVITY: 'Activity',
	ACTIVITY_GRID: 'ActivityGrid',
	ACTIVITY_BUILDER: 'ActivityBuilder',
	EDIT_ACTIVITY: 'EditActivity',
	ADD_ACTIVITY: 'AddActivity',

	FORM_BUILDER: 'FormBuilder',
	EDIT_INVENTORY_FORM: 'EditInventoryForm',
	ADD_INVENTORY_FORM: 'AddInventoryForm',

	DATA_IMPORT: 'DataImport',
	DATA_IMPORT_TEMPLATES: 'Templates',

	DATA_EXPORT: 'DataExport',

	USER_MANAGEMENT: 'UserManagement',
	USER_MANAGEMENT_ADMIN_EDIT: 'AdminUserManagementEdit',
	USER_MANAGEMENT_ADMIN_ADD: 'AdminUserManagementAdd',
	USER_MANAGEMENT_CLIENT_EDIT: 'ClientUserManagementEdit',
	USER_MANAGEMENT_CLIENT_ADD: 'ClientUserManagementAdd',

	REPORT_BUILDER: 'ReportBuilder',
	REPORT_DETAILS: 'ReportDetails',
	WORKBOOK_DETAILS: 'WorkbookDetails',

	PROJECT_CLONE: 'ProjectClone',

	SETTINGS: 'Settings',
	DATABASE_TABLES: 'DatabaseTables',
	DATASET_FIELDS: 'DatasetFields',
	GENERAL_SETTINGS: 'GeneralSettings',
	MERGE_CONDITIONS: 'MergeConditions',
	PERMISSIONS: 'Permissions',
	REFERENCE_LISTS: 'ReferenceLists',
	CONNECTORS: 'Connectors',

	CLIENTS: 'Clients',
	CLIENTS_EDIT: 'ClientsManagementEdit',
	CLIENTS_ADD: 'ClientsManagementAdd',

	PROJECTS: 'Projects',
	PROJECTS_EDIT: 'ProjectsManagementEdit',
	PROJECTS_ADD: 'ProjectsManagementAdd',
});
